import type { CaptureMode } from '../state/store';

interface Props {
  mode: CaptureMode;
  disabled?: boolean;
  onChange(mode: CaptureMode): void;
  /** When provided, restricts the visible modes to this subset. */
  allowed?: readonly CaptureMode[];
}

const MODES: { id: CaptureMode; label: string }[] = [
  { id: 'single', label: 'Single' },
  { id: 'strip3', label: '3-Strip' },
  { id: 'strip4', label: '4-Strip' },
  { id: 'video', label: 'Video' },
];

export function ModePicker({ mode, disabled, onChange, allowed }: Props) {
  const visible = allowed
    ? MODES.filter((m) => allowed.includes(m.id))
    : MODES;
  return (
    <div role="tablist" aria-label="Capture mode" style={{ display: 'flex', gap: 4 }}>
      {visible.map((m) => {
        const active = m.id === mode;
        return (
          <button
            key={m.id}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange(m.id)}
            style={{
              minHeight: 36,
              padding: '6px 14px',
              borderRadius: 999,
              border: 'none',
              background: active ? 'var(--accent)' : 'transparent',
              color: active ? '#0b0b0f' : 'var(--text)',
              fontWeight: 600,
              fontSize: 14,
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.4 : 1,
            }}
          >
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
